import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { LANDING_GROUPS } from '../landingPages';
import { brand } from '../brand';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.dataflix.navBg,
        color: (theme) => theme.palette.dataflix.navText,
        borderTop: (theme) => `1px solid ${theme.palette.dataflix.line}`,
      }}
    >
      <Container maxWidth="lg">
        {/* The product's pages, so every page that has a footer links to them: this is how a visitor and a crawler find them. Not on an
            employer's own address, which has none of them. */}
        {!brand.employer && (
          <Box sx={{ display: 'grid', gap: { xs: 2, md: 3 }, mb: 2, gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: 'repeat(4, minmax(0, 1fr))' } }}>
            {LANDING_GROUPS.map((group) => (
              <Box key={group.label} component="nav" aria-label={group.label}>
                <Typography variant="overline" component="p" sx={{ fontWeight: 700, opacity: 0.8, lineHeight: 1.8 }}>{group.label}</Typography>
                {group.links.map(([to, label]) => (
                  <Link key={to} component={RouterLink} to={to} color="inherit" underline="hover" variant="body2" sx={{ display: 'block', py: 0.25 }}>{label}</Link>
                ))}
                {group.label === 'Company' && (
                  <Link component={RouterLink} to="/contact" color="inherit" underline="hover" variant="body2" sx={{ display: 'block', py: 0.25 }}>Contact us</Link>
                )}
              </Box>
            ))}
          </Box>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="body2" color="inherit" align="center">
            © {new Date().getFullYear()} Ituka Technologies LLC. All rights reserved.
          </Typography>
          <Link component={RouterLink} to="/privacy-policy" color="inherit" underline="hover" variant="body2">Privacy Policy</Link>
          <Link component={RouterLink} to="/terms-and-conditions" color="inherit" underline="hover" variant="body2">Terms and Conditions</Link>
          {brand.employer && <Typography variant="body2" color="inherit">Powered by {brand.platform}</Typography>}
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 
